import { writable } from 'svelte/store'

export const layerProperties = writable([
    {id:99,idname:'base',name:'Capa base',opacity:100,active:true,group:'base'},
    {id:0,idname:'esri',name:'Esri',opacity:85,active:true,group:'base'},

    {id:1,idname:'open',name:'Open',opacity:72,active:true,group:'base'},
    {id:2,idname:'conabio',name:'Conabio',opacity:80,active:true,group:'base'},
    {
        id:3,idname:'empty',name:'Conabio',opacity:100,active:true,group:'base'
    },
    {
        id:4,idname:'pcalor',name:'Punto de calor',opacity:90,identify:true,
        active:true,group:'temas',subgrupo:'pcalor',selected:true,legendName:'Punto de calor',
        legend:[{key:'Diurnos',color:'#fffff'},{key:'Nocturnos',color:'rgba(103, 13, 3, 1)'}]
    },
    {id:5,idname:'pcalorxcluster',name:'Cluster 48 hrs.',opacity:100,active:false,group:'temas',subgrupo:'pcalor',
    legendName:'Clúster de puntos</br> de calor de 48 hrs.',
    legend:[
    {key:'Polígonos de clústeres',color:'#b07d40'}
    ]
    },
    {
        id:6,idname:'pEstables',name:'Puntos estables',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'pcalor',
        legendName:'Polígonos de puntos</br> de calor estables',
        legend:[
            {key:'Industria',color:'#026eff'},
            {key:'Volcanes',color:'#a65304'},
            {key:'Poblados',color:'#7df8dd'},
            {key:'Otros',color:'#fcfe76'},
        ]
    },
    {id:7,idname:'pCalor10pc1hr',name:'Puntos de calor:(Última hora)',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'pcalor',
    legendName:'Puntos de calor</br>GOES(ABI)',
    legend:[
    {key:'Puntos de calor última hora',color:'#fe0100'}
    ]},
    {id:8,idname:'heatmap24h',name:'Densidad de puntos (24h)',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'pcalor'},
    {id:9,idname:'stacker24h',name:'Clúster de puntos:(24h/Lanot:UNAM)',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'pcalor'},
    {id:10,idname:'humedadIdHrgbA',name:'Modelo de humedad',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta',selected:false,
    legendName:'% de humedad de<br>combustible muerto',
    legend:[
    {key:'0',color:'#ffffff'},
    {key:'1-3',color:'#ffff73'},
    {key:'3-5',color:'#ffffbe'},
    {key:'8-11',color:'#beffe8'},
    {key:'11-15',color:'#00c3ff'},
    {key:'15-21',color:'#0070ff'},
    {key:'21-25',color:'#004ca8'},
    {key:'> 25',color:'#002673'}
    ]},
    {id:11,idname:'catFinalNDVI',name:'Anomalías de la vegetación',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta',
    legendName:'Anomalías de la vegetación',
    legend:[
    {key:'Sin vegetación',color:'#ffffff'},
    {key:'Sin anomalía',color:'#89cd63'},
    {key:'Baja',color:'#cfff75'},
    {key:'Moderada',color:'#fdff75'},
    {key:'Alta',color:'#ffa900'},
    {key:'Muy alta',color:'#fe0100'},
    {key:'Sin datos',color:'#cccccc'}
    ]},
    {id:12,idname:'modisFalseColor',name:'MODIS:2021-03-01',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'mosaicos'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico MODIS en falso color con</br>resolución de 250 metros (RGB:7,2,1)',color:''}
    ]},
    {id:13,idname:'viirsFalseColor',name:'VIIRS:2021-03-01',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'mosaicos'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico VIIRS en falso color con</br>resolución de 371 metros (RGB:l-11,l-02,l-01).',color:''}
    ]},
    {id:14,idname:'viirsNight',name:'VIIRS Nocturno:2021-03-02',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'mosaicos',
    legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico VIIRS en color verdadero con</br>resolución de 371 metros (RGB:l-11,l-02,l-01).',color:''}
    ]},
    {id:15,idname:'burnday',name:'AQ MODIS:(diciembre 2020)',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'aquemadas'},
    {id:16,idname:'aq2000_2019',name:'AQ 2000-2019',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'aquemadas',
    legendName:'Áreas quemadas</br>compuesto 2000-2019',
    legend:[
    {key:'0.01-0.05',color:'#f6d400'},
    {key:'0.051-0.06',color:'#f4c400'},
    {key:'0.061-0.018',color:'#f69301'},
    {key:'0.19-0.24',color:'#f56300'},
    {key:'0.25-0.38',color:'#f53100'},
    {key:'0.39-1.0',color:'#f40000'}
    ]},
    {id:17,idname:'aq2000_2019ca',name:'AQ 2000-2019 CA',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'aquemadas',
    legendName:'Áreas quemadas</br>compuesto 2000-2019',
    legend:[
    {key:'0.01-0.05',color:'#f6d400'},
    {key:'0.051-0.06',color:'#f4c400'},
    {key:'0.061-0.018',color:'#f69301'},
    {key:'0.19-0.24',color:'#f56300'},
    {key:'0.25-0.38',color:'#f53100'},
    {key:'0.39-1.0',color:'#f40000'}
    ]},
    {id:18,idname:'nalcms',name:'Cobertura de suelo',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria'
    ,legendName:'Cobertura de suelo',
    legend:[
    {key:'Bosque de coníferas',color:'#003d01'},
    {key:'Bosque de latifoliadas',color:'#016300'},
    {key:'Bosque mixto',color:'#5c752b'},
    {key:'Matorral',color:'#b39e2b'},
    {key:'Pastizal',color:'#e7dc5e'},
    {key:'Humedal',color:'#69a388'},
    {key:'Suelo agrícola',color:'#e7ae67'},
    {key:'Cuerpo de agua',color:'#4c70a4'},
    {key:'Asentamientos humanos',color:'#db2126'}
    ]},
    {id:19,idname:'indiceAmenazaReclass',name:'Índice de Amenaza:de Biodiversidad',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Índice de amenaza</br>a la biodiversidad',
    legend:[
    {key:'Muy Bajo',color:'#266b00'},
    {key:'Bajo',color:'#94bd00'},
    {key:'Medio',color:'#ffff00'},
    {key:'Alto',color:'#fe9900'},
    {key:'Muy Alto',color:'#a80000'},
    ]},
    {id:20,idname:'lucesEstablesMex',name:'Luces Estables México',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Luces Nocturnas</br>compuesto 2016</br> promedio de la radianza',
    legend:[
    {key:'0',color:'#000000'},
    {key:'0.0 - 0.15',color:'#686868'},
    {key:'0.15 - 0.25',color:'#002573'},
    {key:'0.25 - 0.50',color:'#0085a8'},
    {key:'0.50 - 1.50',color:'#56fa5d'},
    {key:'1.50 - 10',color:'#ffff00'},
    {key:'10 - 50',color:'#e59800'},
    {key:'50 - 75',color:'#e54c00'},
    {key:'> 75',color:'#a80000'}
    ]},
    {id:21,idname:'lucesRasterCA',name:'Luces Estables CA',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Luces Nocturnas compuesto 2016</br> promedio de la radianza',
    legend:[
    {key:'0',color:'#000000'},
    {key:'0.0 - 0.15',color:'#686868'},
    {key:'0.15 - 0.25',color:'#002573'},
    {key:'0.25 - 0.50',color:'#0085a8'},
    {key:'0.50 - 1.50',color:'#56fa5d'},
    {key:'1.50 - 10',color:'#ffff00'},
    {key:'10 - 50',color:'#e59800'},
    {key:'50 - 75',color:'#e54c00'},
    {key:'> 75',color:'#a80000'}
    ]},
    {id:22,idname:'anp',name:'Áreas Naturales Protegidas',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Áreas Naturales Protegidas (ANP\'s)',
    legend:[
    {key:'<img style="width: 230px;" src="static/png/anp.png" />',color:''}
    ]},
    {id:88,idname:'aqmodis',name:'aqmodis',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'aquemadas',
    legendName:'aqmodis',
    legend:[
    {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:89,idname:'aqmodis_outline',name:'aqmodis_outline',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'aqmodis_outline',
    legend:[
    {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:23,idname:'centrosRegionales',name:'Centros Regionales:de Manejo del Fuego',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Centros regionales de manejo</br>del fuego (CONAFOR)',
    legend:[
    {key:'Noroeste',color:'#fe9659'},
    {key:'Norte',color:'#c4e437'},
    {key:'Noreste',color:'#89cd66'},
    {key:'Occidente',color:'#6dd0e1'},
    {key:'Centro',color:'#7c65cd'},
    {key:'Sureste',color:'#fc75dd'}
    ]},
    {id:24,idname:'areas_prioritarias',name:'Áreas Prioritarias de Protección:Contra Incendios Forestales',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Áreas Prioritarias de protección</br>contra incendios forestales</br>(CONAFOR)',
    legend:[
    {key:'Baja prioridad',color:'#39a602'},
    {key:'Media prioridad',color:'#effa38'},
    {key:'Alta prioridad',color:'#effa38'}
    ]},
    {id:25,idname:'paisEstado',name:'Frontera de estados',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Fronteras',
    legend:[
    {key:'País',color:'#ce4b1b'},
    {key:'Estado',color:'#ffffff'}
    ]},
    {id:26,idname:'mosaicoViirsWorkspace',name:'Color verdadero',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'mosaicos',legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico MODIS en color verdadero con</br>resolución de 250 metros (RGB:7,2,1)',color:''}
    ]},
    {id:27,idname:'viirsTrueColor',name:'Color verdadero',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'mosaicos',legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico VIIRS en color verdadero con</br>resolución de 371 metros (RGB:l-11,l-02,l-01).',color:''}
    ]},
    {id:28,idname:'viirsNight',name:'Nocturno',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'mosaicos',legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico VIIRS nocturno con</br>resolución de 1,000 metros (RGB:DNB).',color:''}
    ]},
    {id:29,idname:'burnday',name:'AQ MODIS (Febrero 2021)',opacity:100,active:false,myselect:false,group:'temas',subgrupo:'aquemadas',legendName:'Áreas quemadas</br>MODIS (500 metros)',
    legend:[
    {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:30,idname:'clusters',name:'Cluster prueba',opacity:100,active:false,group:'temas',subgrupo:'pcalor'},
    {id:31,idname:'pcalorCluster',name:'Cluster (48 hrs.)',opacity:100,active:false,group:'temas',subgrupo:'pcalor'},
    {id:32,
    idname:'pcalorfiltro',
    name:'Punto de calor (filtro)',
    opacity:90,
    active:false,
    group:'filtro',
    subgrupo:'pcalor',
    filter:false,
    legend:[{key:'Diurnos',color:'#ebed04'},{key:'Nocturnos',color:'red'}],
    selected:false,
    config:false
    },
    {id:33,idname:'estados',name:'estados',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Estados test',
    legend:[
        {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:34,idname:'pcalor01_2021',name:'pcalor01_2021',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Estados test',
    legend:[
        {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:35,idname:'pcalor02_2021',name:'pcalor02_2021',opacity:60,active:false,identify:false,myselect:false,group:'consulta',subgrupo:'complementaria',
    legendName:'Estados test',
    legend:[
        {key:'Polígono de áreas quemadas',color:'#b07d40'}
    ]},
    {id:36,idname:'goesFalseColor',name:'goes',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'mosaicos'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico GOES en falso color con</br>-----',color:''}
    ]},
    {id:37,idname:'goesTrueColor',name:'goes',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'mosaicos'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico GOES en color verdadero con</br>-----',color:''}
    ]},
    {id:40,idname:'googleHybrid',name:'Google Hybrid',opacity:100,active:false,group:'consulta',subgrupo:'complementaria'},
    {id:100,idname:'goes_winds',name:'goes_winds',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico GOES en color verdadero con</br>-----',color:''}
    ]},
    {id:101,idname:'goes_glm',name:'goes_glm',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico GOES en color verdadero con</br>-----',color:''}
    ]},
    {id:102,idname:'goes_rain',name:'goes_rain',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta'
    ,legendName:'Últimas imagénes recibidas',
    legend:[
    {key:'Mosaico GOES en color verdadero con</br>-----',color:''}
    ]},
    {id:103,idname:'goes_mh',name:'goes_mh',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta'
    ,legendName:'Modelo de humedad GOES',
    legend:[
    {key:'Modelo de humedad GOES</br>-----',color:''}
    ]},
    {id:104,idname:'goes_mh_qa',name:'goes_mh_qa',opacity:100,active:false,myselect:false,group:'consulta',subgrupo:'alerta'
    ,legendName:'Modelo de humedad GOES',
    legend:[
    {key:'Modelo de humedad GOES</br>-----',color:''}
    ]},
    {
        id:105,idname:'goes_points',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI LANOT',
        legend:[{key:'Punto de calor',color:'red'}]
    },
    {
        id:106,idname:'goes_heatmap_points',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI LANOT',
        legend:[{key:'Punto de calor',color:'red'}]
    },
    {
        id:107,idname:'goes_heatmap',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI LANOT',
        legend:[{key:'Punto de calor',color:'red'}]
    },
    {
        id:108,idname:'goes_fdcf_10min',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI NOAA',
        legend:[{key:'0-20',color:'#faebdd'}]
    },
    {
        id:109,idname:'goes_fdcf_heatmap_point',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI NOAA',
        legend:[{key:'0-20',color:'#faebdd'}]
    },
    {
        id:110,idname:'goes_fdcf_heatmap',name:'Punto de calor GOES',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'pcalor',selected:false,legendName:'GOES ABI NOAA',
        legend:[{key:'0-20',color:'#faebdd'}]
    },
    {
        id:120,idname:'rave',name:'rave',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'aquemadas',selected:false,legendName:'rave',
        legend:[{key:'0-20',color:'#faebdd'}]
    },
    {
        id:121,idname:'rave_24h',name:'rave_24h',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'aquemadas',selected:false,legendName:'rave_24h',
        legend:[{key:'0-20',color:'#faebdd'}]
    },
    {
        id:122,idname:'fire_pressure',name:'fire_pressure',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'analisis',selected:false,legendName:'fire_pressure',
        legend:[{key:'fire_pressure',color:'#faebdd'}]
    },
    {
        id:123,idname:'aq_modis_last',name:'aq_modis_last',opacity:90,identify:true,
        active:false,group:'temas',subgrupo:'aquemadas',selected:false,legendName:'aq_modis_last',
        legend:[{key:'aq_modis_last',color:'#faebdd'}]
    },
    {
        id:130,idname:'lightningcast',name:'Pronóstico de rayos 1h',opacity:100,identify:false,
        active:false,group:'consulta',subgrupo:'alerta',selected:false,legendName:'Probabilidad de rayos (1h)',
        legend:[
            {key:'10%',color:'#440154'},
            {key:'25%',color:'#31688e'},
            {key:'50%',color:'#35b779'},
            {key:'75%',color:'#fde725'}
        ]
    },
    {
        id:131,idname:'goes_aod',name:'Profundidad óptica de Aerosoles',opacity:100,identify:false,
        active:false,group:'consulta',subgrupo:'aquemadas',selected:false,legendName:'Profundidad óptica de Aerosoles (AOD)',
        legend:[
            {key:'GOES - AOD',color:''}
        ]
    }

])